import { render, staticRenderFns } from "./MemberTrend.vue?vue&type=template&id=2bf2c37a&scoped=true"
import script from "./MemberTrend.vue?vue&type=script&lang=js"
export * from "./MemberTrend.vue?vue&type=script&lang=js"
import style0 from "./MemberTrend.vue?vue&type=style&index=0&id=2bf2c37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2c37a",
  null
  
)

export default component.exports